import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'align-right', 'AlignRight', [["path",{"d":"M4 6l16 0"}],["path",{"d":"M10 12l10 0"}],["path",{"d":"M6 18l14 0"}]]);